module.exports = __webpack_public_path__ + "static/media/background.3b2499de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/epassi/media/background.jpg
// module id = 843
// module chunks = 0